import ReactGA from 'react-ga';
import TagManager from 'react-gtm-module';
import APPLICATION_CONSTANTS from '../applicationConstants';

export function generateIdentifierForGa(practice) {
  const eExpertBadge = 'E_EXPERT';
  const badge = practice?.badges?.includes(eExpertBadge) ? 'ESSILOR_EXPERT;' : '';
  const gaTrackingLabel = `${practice.identifier};${badge}`;

  return gaTrackingLabel;
}

export function generateLocationForEvent(practice) {
  const {
    name,
    city,
    country,
    address1,
    address2
  } = practice;

  return `${name} ${address1}${address2 ? `, ${address2}` : ''}, ${city}, ${country}`;
}


/**
 * 
 * @param {*} dataLayer 
 */
export function gtagPushEvent(dataLayer) {
  dataLayer &&
    TagManager.dataLayer({ dataLayer });
}

/**
 * 
 * @param {*} config 
 * @param {*} route 
 */
export function trackPageView(config, route) {
  const mainPage = config.qa_route_name;
  const subPage = APPLICATION_CONSTANTS.GLOBAL.CURRENT_LANDING_PAGE;

  ReactGA.pageview(`${mainPage}${route}${subPage ? `/${subPage}` : ''}`);
}

/**
 * 
 * @param {*} event 
 */
export function trackEvent(event) {
  if (Object.keys(event).length > 0) {
    const {
      GA,
      GTM,
      API,
      GA_Exception
    } = event;

    if (API) {
      // TODO: DO WE NEED THIS ANYMORE?
    }
    else if (GA_Exception) {
      ReactGA.exception(GA_Exception);
    }
    else {
      ReactGA.event(GA ?? GTM);
    }

    gtagPushEvent(GTM ?? GA);
  }
}
